import { render, staticRenderFns } from "./imgV.vue?vue&type=template&id=376f5b1d"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('376f5b1d')) {
      api.createRecord('376f5b1d', component.options)
    } else {
      api.reload('376f5b1d', component.options)
    }
    module.hot.accept("./imgV.vue?vue&type=template&id=376f5b1d", function () {
      api.rerender('376f5b1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholdersNew/imgV.vue"
export default component.exports